// Generated by genversion.
export const version = '1.12.0';
